import React from 'react';
import { Crop32Outlined } from '@mui/icons-material';
import { Spacer, SpacerPropsSchema } from './Spacer';
import SpacerSidebarPanel from './SpacerSidebarPanel';
export default {
    label: 'Spacer',
    icon: React.createElement(Crop32Outlined, null),
    type: 'Spacer',
    defaultData: {
        props: { height: 16 },
    },
    SidebarPanel: SpacerSidebarPanel,
    Component: Spacer,
    schema: SpacerPropsSchema,
};
//# sourceMappingURL=index.js.map